import React, {useCallback, useEffect, useState} from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import '../../assets/css/carousel.css';
import StarsFront from '../shared/starts-front.client';

export default function ReviewsCarousel({productReviews}) {  
  const [viewportRef, embla] = useEmblaCarousel({align: 'start'});

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const [prevBtnVisible, setPrevBtnVisible] = useState(false);
  const [nextBtnVisible, setNextBtnVisible] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  const scrollTo = useCallback(
    (index) => embla && embla.scrollTo(index),
    [embla],
  );

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on('select', onSelect);
  }, [embla, setScrollSnaps, onSelect]);

  useEffect(()=>{
    if(productReviews && productReviews.length < 3){
      setPrevBtnVisible(true);
      setNextBtnVisible(true);
    }

    try{
      if(productReviews){
        for(let item of productReviews){
          let myDate = item.date.split("-");
          let newDate = new Date( myDate[0], myDate[1] , myDate[2]);
          item.timestamp = newDate.getTime();
        }
        
        const compare =  (a, b) => {
          if (!a.timestamp || !b.timestamp) {
            return 0;
          }
  
          if (a.timestamp > b.timestamp) {
            return -1;
          }
        
          if (a.timestamp < b.timestamp) {
            return 1;
          }
        
          return 0;
        }
  
        productReviews.sort(compare);
      }
    }catch(e){
       console.log('productReviews ERROR', productReviews)
    }
  }, []);

  const nameUser = (name) => {
    try{
      return name.split(' ')[0]; 
    }catch(e){
      return '';
    }
  }

  const dateFormat = (item) => {
    try{
      let newDate = item.date.split('-');
      return newDate[2]+'/'+newDate[1]+'/'+newDate[0];
    }catch(e){
      return '';
    }
  }

  return (<>
    <section className="relative">

      <div className="overflow-hidden ">
        <h2 className="section-title mb-8">Opiniones destacadas</h2>
        <div ref={viewportRef}>
          <div className="my-5 embla__container flex ">
            {productReviews ? productReviews.map((item)=>{
              return (<>
                <div
                    className="review__slide md:w-5/12 xs:w-full p-5 cad-reviews"
                    key={item._key}
                  >
                    <div className="rounded-md bg-white p-6 shadow-sm border-gray-60 border-2 card-review-comment">
                      <div className="flex justify-between mb-5 review-head">
                      <div>
                        <p className="font-bold text-xl"> {nameUser(item.title)} </p>
                      </div>
                        <p className="font-bold text-purple-450">
                        {dateFormat(item)}{' '}
                        </p>
                      </div>
                      <div className="review-stars">
                        <StarsFront userCalification={item.calification}  />
                      </div>
                      <div className='review-text'>{item.body}</div>
                    </div>
                  </div>
              </>)
            }): ''}
          </div>
        </div>
      </div>
    </section>
  </>

    // <section className="relative">
    //   {(sanity && sanity[0]?.title ) && (
    //   <><div className="overflow-hidden ">
    //       <h2 className="section-title mb-8">Opiniones destacadas</h2>
    //       <div ref={viewportRef}>
    //         <div className="my-5 embla__container flex ">
    //           {sanity
    //             ? sanity.map((item) => {
    //               return (
    //                 <div
    //                   className="review__slide md:w-5/12 xs:w-full p-5 cad-reviews"
    //                   key={item._key}
    //                 >
    //                   <div className="rounded-md bg-white p-6 shadow-sm border-gray-60 border-2 card-review-comment">
    //                   <div className="flex justify-between mb-5 review-head">
    //                     <div>
    //                     <p className="font-bold text-xl"> {nameUser(item.title)} </p>
    //                     </div>
    //                     <p className="font-bold text-purple-450">
    //                     {dateFormat(item)}{' '}
    //                     </p>
    //                   </div>
    //                   <div className="review-stars">
    //                     <StarsFront userCalification={item.calification}  />
    //                   </div>
    //                   {/* <p className="font-bold text-xl mb-2 text-purple-450">
    //                     {' '}
    //                     {nameUser(item.title)}
    //                   </p> */}
    //                   <div className='review-text'>{item.body}</div>
    //                   </div>
    //                 </div>
    //               );
    //             })
    //             : ''}
    //         </div>
    //       </div>
    //     </div>
    //     <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} visibility={prevBtnVisible} />
    //     <NextButton onClick={scrollNext} enabled={nextBtnEnabled} visibility={nextBtnVisible} /></>
    //   )}
    // </section>
  );
}

const PrevButton = ({enabled, onClick, visibility}) => (
  <button
    className="absolute top-1/2 left-0 bottom-52 flex items-center justify-center rounded-full h-10 w-10 bg-gray-60 cursor-pointer"
    onClick={onClick}
    disabled={!enabled}
    style={{visibility: (visibility)?'hidden':''}}
  >
    <svg
      className="embla__button__svg h-5 w-5  fill-purple-120"
      viewBox="137.718 -1.001 366.563 644"
    >
      <path d="M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z" />
    </svg>
  </button>
);

const NextButton = ({enabled, onClick, visibility}) => {
  return (
    <button
      className={` ${
        !enabled ? 'fill-gray-300' : 'fill-purple-120'
      } absolute top-1/2 right-0 bottom-52 flex items-center justify-center rounded-full h-10 w-10 bg-gray-60 cursor-pointer`}
      onClick={onClick}
      disabled={!enabled}
      style={{visibility: (visibility)?'hidden':''}}
    >
      <svg
        className={`embla__button__svg  h-5 w-5 fill-purple-120  ${
          !enabled ? 'fill-gray-300' : 'fill-purple-120'
        }`}
        viewBox="0 0 238.003 238.003"
      >
        <path d="M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z" />
      </svg>
    </button>
  );
};
